/* src/app/modules/shared/components/column/column-terpene/column-terpene.component.scss */
app-column-terpene {
  display: contents;
}
/*# sourceMappingURL=column-terpene.component.css.map */
